export const pathBuilder = (url: URL) => {
  let path = `${url.pathname}`;

  // my attempts to get the size of the url.searchParams are
  // not meeting with success in ts.  need to revisit.
  //@ts-ignore
  const keys = Array.from(url.searchParams);
  if (keys.length) {
    path = `${path}?${url.searchParams}`;
  }

  if (url.hash) {
    path = `${path}${url.hash}`;
  }

  return path;
};
